import React, { useState } from 'react';
import '../css/HomeHeader.css';
import video1 from '../../images/homevdo1-new.mp4';
import video2 from '../../images/homevdo2-new.mp4';
import video3 from '../../images/homevdo3-new.mp4';
import video4 from '../../images/homevdo4-new.mp4';

const videoData = [
    {
        video: video1,
        heading: '#1 Global IT and Digital Transformation',
        description: 'Revolutionizing Technology , Innovation at its Best , The Next Generation of IT',
        buttonheading: 'Digital Transformation',
        buttondescription: 'Building custom software for growth across USA, UAE, Canada, UK, and Saudi Arabia.',
    },
    {
        video: video2,
        heading: 'Driving Into Tomorrow',
        description: 'Tech at the Speed of Light, Innovative Solutions, Shaping the Future',
        buttonheading: 'Metaverse',
        buttondescription: 'Designing immersive metaverse experiences for the next generation of reality.',
    },
    {
        video: video3,
        heading: 'Engineering Speed and Style',
        description: 'Speed Meets Design, Crafting Stylish Solutions, Agile Development',
        buttonheading: 'Artificial Intelligence',
        buttondescription: 'Developing AI solutions that redefine innovation, automation, and intelligence.',
    },
    {
        video: video4,
        heading: 'Eco-Friendly and Efficient Journeys',
        description: 'Eco-Friendly Tech, Driving Efficiency, Empowering Green Tech',
        buttonheading: 'Virtual/Augmented Reality',
        buttondescription: 'Unlocking immersive business experiences through AR and VR technologies today.',
    },
];

function HomeHeader() {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="home-header-section position-relative">
            {/* Background Video */}
            <video
                className="w-100 h-100 object-fit-cover position-absolute top-0 start-0"
                autoPlay
                muted
                loop
                playsInline
                key={videoData[activeIndex].video}
            >
                <source src={videoData[activeIndex].video} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Dark Overlay */}
            <div className="overlay position-absolute top-0 start-0 w-100 h-100" />

            {/* Main Text Content */}
            <div className="container position-relative z-1 text-white d-flex align-items-center h-100">
                <div className="text-center text-md-start w-100">
                    <h1 className="display-4 fw-bold"><b>{videoData[activeIndex].heading}</b></h1>
                    <p className="lead fw-bold">{videoData[activeIndex].description}</p>
                    <button className="btn custom-orange-btn py-2 px-5 fw-bold mt-3" onClick={() => window.location.href = '/contact-us'}>Get in Touch with Us</button>
                </div>
            </div>

            {/* 4-Box Selector Fixed to Bottom */}
            <div className="selector-bar position-absolute bottom-0 start-0 w-100 z-2">
                <div className="container-fluid px-3">
                    <div className="row g-2">
                        {videoData.map((item, index) => (
                            <div key={index} className="col-6 col-md-3">
                                <div
                                   className={`select-box p-3 text-center rounded border ${activeIndex === index ? 'active-box' : 'border-white'}`}
                                    style={{ cursor: 'pointer', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: 'white' }}
                                    onClick={() => setActiveIndex(index)}
                                >
                                    <h6 className="fw-bold mb-1">{item.buttonheading}</h6>
                                   <p className="small mb-0 d-none d-md-block">{item.buttondescription}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeHeader;
